import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { TReduxStore } from '../../../shared/types/redux';

import { ICustomContextParams } from '../../../shared/types/ICustomContextParams';
import { Application } from '../../../shared/containers/App/App';

interface IDependencies {
  store: TReduxStore;
}

export function renderApplication(dependencies: IDependencies) {
  const config = getConfig();
  const { store } = dependencies;
  //await scrollToTopOf(hash);

  const projectName = config.getStrict<string>('projectName');
  const customContext = config.getStrict<ICustomContextParams>('applicationContext.custom');
  const rootElement = document.getElementById(projectName as string);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  ReactDOM.hydrate(
    <Application config={config} logger={getLogger()} reduxStore={store} customContext={customContext} />,
    rootElement,
  );
}
